import usePrivateAxios from '@/common/api/usePrivateAxios';
import { useMutation } from '@tanstack/react-query';

interface UseBillingFiscalDocumentCancel {
  fiscalDocumentId?: string;
  onSuccess?: (response: any) => void;
  onError?: (response: any) => void;
}

export const useBillingFiscalDocumentCancel = ({ fiscalDocumentId, onSuccess, onError }: UseBillingFiscalDocumentCancel) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['billingFiscalDocumentCancel', fiscalDocumentId],
    mutationFn: () => privateAxios.put(`/billing/fiscal_documents/${fiscalDocumentId}/cancel`),
    onSuccess,
    onError,
  });
};
